/**
 * Chummys story — <chummys-story>
 *
 * Writes one number, --story-p, as the band crosses the viewport: 0 when its
 * top reaches the bottom of the window, 1 when its bottom leaves the top. The
 * photograph's parallax and the overlapping card read it from CSS. It also
 * adds `is-in` the first time the band is on screen, which is what lets the
 * copy rise in. Nothing here runs while the band is off screen.
 */
(() => {
  if (customElements.get('chummys-story')) return;

  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class ChummysStory extends HTMLElement {
    constructor() {
      super();
      this.visible = false;
      this.raf = null;
      this.onScroll = this.onScroll.bind(this);
      this.tick = this.tick.bind(this);
    }

    connectedCallback() {
      this.io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          this.visible = e.isIntersecting;
          if (e.isIntersecting) {
            this.classList.add('is-in');
            this.onScroll();
          }
        }
      }, { rootMargin: '12% 0px', threshold: [0, 0.1] });
      this.io.observe(this);

      if (reduced) {
        this.style.setProperty('--story-p', '0.5');
        return;
      }
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.tick();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.io) this.io.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    onScroll() {
      if (!this.visible || this.raf) return;
      this.raf = requestAnimationFrame(this.tick);
    }

    tick() {
      this.raf = null;
      const r = this.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      this.style.setProperty('--story-p', p.toFixed(4));
    }
  }

  customElements.define('chummys-story', ChummysStory);
})();
